import { object, string, null as zNull } from "zod/v4";

export const createReviewDiscount = {
  name: "createReviewDiscount" as const,
  input: object({ reviewId: string() }),
  output: object({
    discountCode: string(),
    formattedDiscountString: string(),
  }).or(zNull()),
};
